import React, { useEffect } from "react";
import { Button, Row, Col, Empty, Card } from "antd";
import { Region } from "../../common/layout/region";
import Loading from "../../common/loading";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import "./style.css";
import Project from "./project";
import { useState } from "react";
import CreateProjectModal from "./createProjectModal";
import EditProjectModal from "./editProjectModal";
import DeleteProjectModal from "./deleteProjectModal";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
	getInternshipJobs,
	resetInternshipJobList,
} from "../../../actions/internshipJobPostingActions";
import GalkButton from "../../common/component/button";

const ProjectInformation = ({
	companyId,
	projectList,
	isLoading,
	getInternshipJobs,
	resetInternshipJobList,
}) => {
	const [showEditModal, setShowEditModal] = useState(false);
	const [projectToEdit, setProjectToEdit] = useState(null);
	const [projectToDelete, setProjectToDelete] = useState(null);
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [isTagEngineerModalOpen, setIsTagEngineerModalOpen] = useState(false);
	const [isMatchModalOpen, setIsMatchModalOpen] = useState(false);
	const [selectedProject, setSelectedProject] = useState(null);
	const { t } = useTranslation();

	useEffect(() => {
		if (companyId && !projectList) {
			getInternshipJobs();
		}
	}, [companyId, projectList]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		return () => {
			resetInternshipJobList();
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const editJob = (job, index) => {
		setProjectToEdit({ ...job, index });
		setShowEditModal(true);
	};
	const closeEditModal = () => {
		setProjectToEdit(null);
		setShowEditModal(false);
	};

	const deleteJob = (job, index) => {
		setProjectToDelete({ ...job, index });
		setShowDeleteModal(true);
	};
	const closeDeleteModal = () => {
		setProjectToDelete(null);
		setShowDeleteModal(false);
	};

	const closeCreateModal = () => {
		setShowCreateModal(false);
	};

	return (
		<Region>
			{(isLoading || !projectList) && <Loading />}
			{projectList && (
				<div className="internship_projectInformation_pageContainer">
					<div className="pageHeader_row">
						<div className="determineIntrn_container_card_title_container">
							<div className="determineIntrn_container_card_title_primary">
								{t("projectInformation_pageHeader_primary")}
							</div>
							<div className="determineIntrn_container_card_title_secondary">
								<span>{t("projectInformation_pageHeader_secondary")}</span>
							</div>
						</div>
						<div style={{ alignSelf: "end" }}>
							<GalkButton
								type="primary"
								onClick={() => setShowCreateModal(true)}
								icon={<PlusOutlined />}
								disabled={isLoading}
								width={180}
							>
								{t("projectInformation_pageHeader_actionButton")}
							</GalkButton>
						</div>
					</div>
					<div className="project_container">
						{projectList && projectList.length < 1 && (
							<div
								style={{
									display: "flex",
									flexDirection: "divumn",
									justifyContent: "center",
									width: "100%",
									height: "65vh",
								}}
							>
								<Empty />
							</div>
						)}
						{projectList &&
							projectList.map((project, index) => (
								<Project
									key={index}
									editHandler={editJob}
									index={index + 1}
									project={project}
									deleteHandler={deleteJob}
									// tagModal={setIsTagEngineerModalOpen}
									// matchModal={setIsMatchModalOpen}
								/>
							))}
					</div>
					{showCreateModal && (
						<CreateProjectModal
							modalCloseHandler={closeCreateModal}
							newProjectIndex={projectList ? projectList.length + 1 : ""}
						/>
					)}

					{showEditModal && (
						<EditProjectModal
							projectDetails={projectToEdit}
							modalCloseHandler={closeEditModal}
						/>
					)}
					{showDeleteModal && (
						<DeleteProjectModal
							projectDetails={projectToDelete}
							modalCloseHandler={closeDeleteModal}
						/>
					)}
				</div>
			)}
		</Region>
	);
};

const mapStateToProps = (state) => ({
	projectList: state.internshipJobs.jobList,
	isLoading: state.internshipJobs.isListLoading,
	companyId: state.company.company.id,
});

export default connect(mapStateToProps, {
	getInternshipJobs,
	resetInternshipJobList,
})(withRouter(ProjectInformation));
